import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import ModalContainer from '../ModalContainer'
import YouTubePlayer from '../../Global/YouTubePlayer'

// Actions
import { showModal, hideModal } from '../../../actions/modal'

class MarketingLearnMoreModal extends Component {
  handleLearnMoreClick = (type) => {
    let optionalProps = {}

    if (type === 'market') {
      optionalProps = {
        surheading: '01',
        heading: 'Market',
        content: `
          <p>Our Platform builds YOUR Athletic Resume to Showcase</p>
          <ul>
            <li>Your Player Bio and rankings</li>
            <li>Your highlight videos and photos</li>
            <li>Your Awards and Achievements</li>
            <li>Your Game Stats</li>
            <li>Your Camps attended</li>
            <li>Your important Contact info</li>
          </ul>
        `,
        videoId: '2mDXQ-Htm0c',
        nextLinkModal: 'network',
        nextLinkText: '02 Network'
      }
    } else if (type === 'network') {
      optionalProps = {
        surheading: '02',
        heading: 'Network',
        content: `
          <p>Get access to 58,000 Coaches in our extensive network</p>
          <ul>
            <li>Get direct emails and phone numbers.</li>
            <li>Search every college and university, every division, every conference, and every state.</li>
            <li>Build your own Network of College Coaches to share your Profile.</li>
            <li>Fast and easy to use time saver.</li>
          </ul>
        `,
        videoId: 'Wq43ZqiaXs4',
        nextLinkModal: 'educate',
        nextLinkText: '03 Educate'
      }
    } else if (type === 'educate') {
      optionalProps = {
        surheading: '03',
        heading: 'Educate',
        content: `
          <p>Get Access to Recruiting Resources</p>
          <ul>
            <li>Grade level Recruiting Checklists</li>
            <li>How to Market Yourself</li>
            <li>Important Academic Requirements</li>
            <li>Recruiting Calendars and Guides</li>
            <li>Communications Etiquette</li>
            <li>Recruiting Process</li>
            <li>Tips on Questions to Ask and Answer during visits</li>
            <li>So Much More</li>
          </ul>
        `,
        videoId: '7qEYApI_h6U',
        nextLinkModal: 'market',
        nextLinkText: '01 Market'
      }
    }

    this.props.showModal({
      modalType: 'learn-more',
      optionalProps
    })
  }

  render() {
    const {
      surheading,
      heading,
      content,
      videoId,
      nextLinkModal,
      nextLinkText
    } = this.props;

    return (
      <ModalContainer
        modalExit={true}
        optionalClasses="modal-learn-more"
      >
        <div className="modal-section modal-body">
          <div className="modal-content">
            { surheading && <h4>{surheading}</h4> }
            <h2>{ heading ? heading : "Learn More"}</h2>
            { content &&
              <div dangerouslySetInnerHTML={{__html: content}}></div>
            }
          </div>
          <div className="youtube-player-container">
            <YouTubePlayer videoId={videoId} />
          </div>
        </div>
        <div className="modal-section modal-footer">
          <a className="cta" href="/sign-up">Sign Up Now</a>
          { nextLinkModal &&
            <a className="next-link" onClick={() => this.handleLearnMoreClick(nextLinkModal)}>
              <span>{nextLinkText}</span>
              <svg><use xlinkHref="#arrow-right" /></svg>
            </a>
          }
        </div>
      </ModalContainer>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideModal: modalType => {
      dispatch(hideModal())
    },
    showModal: (modalType) => {
      dispatch(showModal(modalType))
    }
  }
}

export default connect(
  null,
  mapDispatchToProps
)(MarketingLearnMoreModal)



// WEBPACK FOOTER //
// ./src/components/Modals/Marketing/MarketingLearnMoreModal.js